import { WalletOptions } from 'components/walletbutton/WalletOptions'
import { IoIosClose } from "react-icons/io";
import { useModal } from "../../providers/providers";
import { useTranslation } from '../../hooks/useTranslation';

const SelectWalletModal = () => {
  const { closeSelectWalletModal } = useModal()
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center w-full h-full">
      <div className='relative flex flex-col gap-4 bg-[#0D1B23] shadow-[#5AF4FF] shadow-[0px_12px_12px_0px] px-6 py-10 border-[#5AF4FF40] border-[1px] rounded-xl w-full max-w-[360px]'>
        <div onClick={() => closeSelectWalletModal()} className='top-3 right-3 absolute flex flex-col justify-center items-center bg-[#0098EA26] hover:bg-[#0098EA40] p-1 rounded-full w-7 h-7 transition-colors cursor-pointer'>
          <IoIosClose className='text-[#0098EA] text-2xl' />
        </div>
        <p className='font-semibold text-white text-xl text-start'>
          {t('wallet.selectWallet')}
        </p>
        <p className="text-white text-sm text-start">
          {t('wallet.selectWalletDesc')}
        </p>
        <WalletOptions />
      </div>
    </div>
  )
}

export default SelectWalletModal
